import { render, staticRenderFns } from "./ranking-factory.vue?vue&type=template&id=8bee9794&scoped=true&"
import script from "./ranking-factory.vue?vue&type=script&lang=js&"
export * from "./ranking-factory.vue?vue&type=script&lang=js&"
import style0 from "./ranking-factory.vue?vue&type=style&index=0&id=8bee9794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bee9794",
  null
  
)

export default component.exports